import { render } from "./TaxEdit.vue?vue&type=template&id=1d8ad818"
import script from "./TaxEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Tax/TaxEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d8ad818"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d8ad818', __exports__)) {
    api.reload('1d8ad818', __exports__)
  }
  
  module.hot.accept("./TaxEdit.vue?vue&type=template&id=1d8ad818", () => {
    api.rerender('1d8ad818', render)
  })

}


export default __exports__